<template>
  <div class="mt-4">
    <div class="d-flex">
      <search-field class="white" v-model="search" />
      <v-spacer></v-spacer>
      <!-- <v-btn @click="removeAll()" v-if="isAdmin">Delete All </v-btn> -->
      <create-condition v-if="isAdmin || isDataEntry || isDataEntryAndDispatcher" />
    </div>
    <v-card :elevation="$root.ele" class="mt-5">
      <v-data-table
        :items-per-page="100"
        :headers="headers"
        :items="filteredConditions"
        fixed-header
        v-model="selected"
        :footer-props="{
          'items-per-page-options': [10, 20, 50, 100, -1],
          'show-first-last-page': true,
        }"
        :height="height"
        class="templates-table"
      >
        <!-- <template v-slot:item.condition="{ item }">
          <div v-html="formatConditions(item)"></div>
        </template>
        <template v-slot:item.perform="{ item }">
          <div v-html="formatPerform(item)"></div>
        </template> -->
        <template v-slot:item.condition_text="{ value }">
          <div v-html="value"></div>
        </template>
        <template v-slot:item.perform_text="{ value }">
          <div v-html="value"></div>
        </template>
        <template v-slot:item.action="{ item }">
          <div class="d-flex">
            <create-condition :isEdit="true" :item="item" />
            <remove-icon-button v-if="isAdmin" @click="remove(item)" />
          </div>
        </template>
      </v-data-table>
    </v-card></div
></template>

<script>
import customerModal from "../../assets/js/customer.modal";
import { fieldConditions, fs } from "../../assets/js/firebase";
import RemoveIconButton from "../buttons/RemoveIconButton.vue";
import SearchField from "../ui/form/SearchField.vue";
import CreateCondition from "./conditions/CreateCondition.vue";
export default {
  components: { CreateCondition, RemoveIconButton, SearchField },
  data() {
    return {
      conditions: [],
      search: "",
      selected: [],
    };
  },
  computed: {
    filteredConditions() {
      let list = [...this.conditions];
      if (this.search) {
        let splits = this.search
          .trim()
          .toLowerCase()
          .split(" ");
        list = list.filter((i) => {
          let items = splits.filter((s) => {
            let c = i.condition_text.toLowerCase();
            let p = i.perform_text.toLowerCase();
            return c.includes(s) || p.includes(s);
          });
          return items.length == splits.length;
        });
      }
      return list;
    },
    height() {
      return window.innerHeight - 330;
    },
    headers() {
      let headers = {
        condition_text: "Conditions",
        perform_text: "Perform",
        createdAt: "Created",
        action: "Action",
      };
      let list = [];
      Object.keys(headers).forEach((value) => {
        let doc = {
          value,
          divider: true,
          class: "text-capitalize",
          text: headers[value].toUpperCase(),
        };
        if (value === "action") {
          doc.divider = false;
          doc.width = "120px";
        }
        list.push(doc);
      });
      return list;
    },
    fields() {
      let globalFields = this.$store.getters.globalFields;
      let serviceFields = this.$store.getters.serviceFields;
      return [...globalFields, ...serviceFields].map((i) => ({
        ...i,
        value: i.id,
      }));
    },
  },
  watch: {
    fieldConditions() {
      this.initConditions();
    },
  },
  methods: {
    remove({ id }) {
      this.$confirm.show({
        message: "Are you sure, Do you want to remove this?",
        onConfirm: async () => {
          try {
            this.$loader.show();
            await fieldConditions.doc(id).delete();
            this.$loader.hide();
          } catch (error) {
            this.$loader.hide();
          }
        },
      });
    },
    getOptionValue({ key, val }) {
      let vm = this;
      let global = vm.$store.getters.globalFields;
      let service = vm.$store.getters.serviceFields;
      let makes = vm.$store.getters.makes;
      let makesUnlocking = vm.$store.getters.makesUnlocking;
      let zips = vm.$store.getters.zipcodes;
      let fields = global.concat(service);
      let item = fields.find((item) => {
        return item.id == key;
      });
      if (item != null) {
        let { field_type, options } = item;
        if (field_type == "select") {
          let opt = options.find((item) => {
            return item.name == val;
          });
          if (opt) val = opt.name;
        }
      }
      if (key == customerModal.MAKE) {
        let item = makes.find((item) => {
          return item.id == val;
        });
        if (item != null) val = item.name;
      }
      if (key == customerModal.MAKE_UNLOCKING) {
        let item = makesUnlocking.find((item) => {
          return item.id == val;
        });
        if (item != null) val = item.name;
      }
      if (key == customerModal.ZIPCODE) {
        let item = zips.find((item) => {
          return item.id == val;
        });
        if (item != null) {
          val = `${item.zipcode} / ${item.community} / ${item.zone}`;
        }
      }
      return val;
    },
    formatPerform({ perform }) {
      let text = ``;
      perform.forEach((item) => {
        let field = this.fields.find((i) => i.id == item.field);
        if (field) {
          let val = this.getOptionValue({ key: item.field, val: item.value });
          text += `<b>${field.name} : </b>${val}<br/>`;
        }
      });
      return text;
    },
    formatConditions({ conditions }) {
      let text = ``;
      conditions.forEach((item) => {
        let field = this.fields.find((i) => i.id == item.field);
        if (field) {
          let condition = `<b>${field.name} : </b>`;
          if (item.condition == "IS EQUAL TO") {
            let val = this.getOptionValue({ key: item.field, val: item.value });
            condition += `${item.condition} -  ${val}`;
          } else {
            condition += `${item.condition} : ${item.start} - ${item.end}`;
          }
          text += `${condition}<br/>`;
        }
      });
      return text;
    },
    initConditions() {
      let list = [];
      for (let item of this.fieldConditions) {
        let doc = { ...item };
        doc.condition_text = this.formatConditions(doc);
        doc.perform_text = this.formatPerform(doc);
        list.push(doc);
      }
      this.conditions = list;
    },
    async removeAll() {
      try {
        this.$loader.show();
        let batch = fs.batch();
        console.log(this.selected);
        this.selected.forEach((i) => {
          batch.delete(fieldConditions.doc(i.id));
        });
        await batch.commit();
        this.selected = [];
        this.$loader.hide();
      } catch (error) {
        this.$loader.hide();
        console.error(error);
      }
    },
  },
  mounted() {
    this.initConditions();
  },
};
</script>

<style></style>
